import { type FC } from "react";
import { Tr } from "@root/shared/components/Table/legacy/Tr";
import { Td } from "@root/shared/components/Table/legacy/Td";
import { Th } from "@root/shared/components/Table/legacy/Th";
import * as styles from "@root/clientFrontend/features/scout/components/UserDetail/uiParts/ThoughtsAndSelfPrTable/styles.css";
import { ReadMoreButton } from "@root/shared/components/ReadMoreButton";

type Props = {
  thContent: React.ReactNode;
  tdContent?: React.ReactNode;
  showReadMoreButton?: boolean;
  maxDisplayLargeTextHeight?: number;
};

export const FullWidthTableRow: FC<Props> = ({
  thContent,
  tdContent,
  showReadMoreButton = false,
  maxDisplayLargeTextHeight = 0,
}) => (
  <Tr>
    <Th className={styles.fullWidthTh}>{thContent}</Th>
    <Td className={styles.fullWidthTd}>
      {showReadMoreButton ? (
        <ReadMoreButton size="large" containerMaxHeight={maxDisplayLargeTextHeight}>
          <>{tdContent}</>
        </ReadMoreButton>
      ) : (
        tdContent
      )}
    </Td>
  </Tr>
);
